module.exports = __webpack_public_path__ + "media/images/application/icons/copyright-e8bb5e45d71d8186c0995cdd595511b9.svg";